import { unwrapEnvelope } from '@/model/client';
import { useLazyGetApiUsersOauthBySubIdQuery } from '@/model/user/api.generated';
import type { UserResponse } from '@/model/user/dto.generated';
import { logger } from '@/shared/helpers/logger';
import { useAppDispatch, useAppSelector } from '@/shared/hooks/useStore';
import { selectUserData, setUser } from '@/viewmodel/features/user/state/userSlice';
import { useCallback } from 'react';

export function useRefreshUser(): () => Promise<void> {
  const dispatch = useAppDispatch();
  const { data: user } = useAppSelector(selectUserData);
  const [triggerGetUser] = useLazyGetApiUsersOauthBySubIdQuery();

  return useCallback(async () => {
    const sub = user?.idp_sub;
    if (!sub) return;
    try {
      const result = await triggerGetUser({ subId: sub }).unwrap();
      const refreshed = unwrapEnvelope<UserResponse>(result);
      dispatch(setUser(refreshed));
    } catch (err) {
      logger.error('useRefreshUser: failed to refresh user data', {
        log_source: 'useRefreshUser',
        error: err instanceof Error ? err : new Error(String(err)),
      });
    }
  }, [dispatch, triggerGetUser, user?.idp_sub]);
}
